import { Container, Typography, Box, Button, useColorScheme } from '@mui/material';
import logoCabanaBlack from '../../images/logonextcabana-dark.svg';
import logoCabanaWhite from '../../images/logonextcabana-white.svg';
import AppTheme from '../../../frontend/shared-theme/AppTheme';
import { applyActionCode, checkActionCode, getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { useEffect, useState } from 'react';
import LinearIndeterminate from '../../../frontend/components/LoadingLinear';
import WarningAlert from '../../../frontend/components/WarningAlert';

function RecoverContent() {
  const { mode, systemMode } = useColorScheme();
  const [code, setCode] = useState('');
  const [resetPassword, setResetPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userEmail, setUserEmail] = useState<string | null | undefined>('');
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const auth = getAuth();

  useEffect(() => {
    if (alert) {
      setTimeout(() => {
        setAlert(false)
      }, 6000)
    }
  }, [alert])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setCode(params.get('oobCode') || '');
  }, []);

  useEffect(() => {
    if (!code) return;

    const getUser = async () => {
      await checkActionCode(auth, code).then((info) => {
        const email = info['data']['email'];
        setUserEmail(email);
      })
      await applyActionCode(auth, code);
      setLoading(false);
    }
    getUser();
  }, [code]);

  const handleResetClick = async () => {
    if (userEmail) {
      try {
        await sendPasswordResetEmail(auth, userEmail);
        setResetPassword(true);
      } catch (error: any) {
        setAlert(true);
        setAlertMessage('Erro ao enviar e-mail de redefinição de senha. Tente novamente.');
        console.error('Erro ao enviar e-mail de redefinição de senha:', error);
      }
    }
  }

  if (loading) {
    return <LinearIndeterminate />;
  }

  return (
    <Container component="main" sx={{ maxWidth: 'xs', textAlign: 'center' }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
        <img
          src={mode === 'dark' || systemMode === 'dark' ? logoCabanaWhite : logoCabanaBlack}
          alt="logo-cabanalink"
          style={{ width: '300px', height: 'auto' }}
        />
      </div>
      {resetPassword ? (
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Typography component="h1" variant="h5" textAlign='center'>
            E-mail de redefinição de senha enviado!
          </Typography>
          <Typography textAlign='center'>
            Um e-mail de redefinição de senha foi enviado para <strong>{userEmail}</strong>.<br />
            Siga as orientações presentes no email para redefinir sua senha.
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Typography component="h1" variant="h5" textAlign='center'>
            Endereço de e-mail atualizado!
          </Typography>
          <Typography textAlign='center'>
            Seu endereço de e-mail de login foi alterado novamente para <strong>{userEmail}</strong>.
          </Typography>
          <Typography textAlign='center'>
            Caso não tenha solicitado a alteração do seu e-mail de login,
            é possível que outra pessoa esteja tentando acessar sua conta. <br />
            Recomendamos fortemente que altere sua senha.
          </Typography>
          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2, maxWidth: '200px' }}
            onClick={handleResetClick}
          >
            Alterar senha
          </Button>
        </Box>
      )}
      {alert && (
        <WarningAlert message={alertMessage} />
      )}
    </Container>
  );
};

export default function RecoverEmail(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <RecoverContent />
    </AppTheme>
  )
}